import Loading from "component/Loading";
import { useEffect, useLayoutEffect, useRef, useState } from "react";

const Editor = ({value}) => {
    const editorRef = useRef();
    // const [editorLoaded, setEditorLoaded] = useState(false);
    // const { CKEditor, ClassicEditor } = editorRef.current || {};

    // useEffect(() => {
    //     editorRef.current = {
    //       CKEditor: require("@ckeditor/ckeditor5-react").CKEditor,
    //       ClassicEditor: require("../../ckeditor-build"),
    //     };
    //     setEditorLoaded(true);
    // }, []);

    return value ? (
        <div className="ck-container container mt-4">
            <div dangerouslySetInnerHTML={{ __html: value}}></div>
            {/* <CKEditor
                editor={ClassicEditor}
                data={value}
                onInit={(editor) => {
                    // You can store the "editor" and use when it is needed.
                    console.log("Editor is ready to use!", editor);
                }}
                onChange={(event, editor) => {
                    const data = editor.getData();
                }}
                config={{
                    toolbar: []
                }}
                disabled={true}
            /> */}
        </div>
    ) : (
        <div className="container mt-4">
            <Loading inline />
        </div>
    );
}

export default Editor;